/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_TitleInputs */

const cs_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditní log`)
};

const en_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log`)
};

/**
* | output |
* | --- |
* | "Audit log" |
*
* @param {Audit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_title = /** @type {((inputs?: Audit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_title(inputs)
	return cs_audit_title(inputs)
});